import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { getBuildStamp } from '@/lib/buildStamp';

const TIMEOUT_MS = 6000;

interface AppLoaderProps {
  text?: string;
}

/**
 * Suspense fallback with a 6-second timeout.
 * After timeout shows "Tap to retry" to escape blank/green screen.
 */
export function AppLoader({ text = 'Loading...' }: AppLoaderProps) {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      console.error('THERAPPI_FATAL: Route mount timed out after 6s');
      setTimedOut(true);
    }, TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, []);

  if (timedOut) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-background z-50 gap-4">
        <p className="text-sm text-muted-foreground">Taking too long to load.</p>
        <button
          onClick={() => window.location.reload()}
          className="flex items-center gap-2 text-primary hover:underline text-sm"
        >
          <RefreshCw className="h-4 w-4" />
          Tap to retry
        </button>
        <p className="text-[9px] font-mono text-muted-foreground/40 mt-4">{getBuildStamp()}</p>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-background z-50 gap-4">
      <div className="h-10 w-10 border-3 border-primary border-t-transparent rounded-full animate-spin" />
      <p className="text-sm text-muted-foreground animate-pulse">{text}</p>
    </div>
  );
}
